import { render, staticRenderFns } from "./ViewSkillOfSpeaking.vue?vue&type=template&id=33ad293a&scoped=true"
import script from "./ViewSkillOfSpeaking.vue?vue&type=script&lang=js"
export * from "./ViewSkillOfSpeaking.vue?vue&type=script&lang=js"
import style0 from "./ViewSkillOfSpeaking.vue?vue&type=style&index=0&id=33ad293a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad293a",
  null
  
)

export default component.exports